<template>
  <b-container class="p-0">
    <b-row no-gutters>
      <b-col>
        <b-form-group
            v-if="label"
            :state="validatedField && validatedField.isValid"
        >
          <slot name="label">
            {{ label }}
          </slot>
        </b-form-group>
        <Picker :placeholder="placeholder" v-model="date" :config="options"
                :custom-focus-on-hide="customFocusOnHide"></Picker>
        <!--        <div v-else class="form-control grey-label notifications-list">{{ date }}</div>-->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

// import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment-timezone";
import LocalDateTime from "@/server/LocalDateTime";
import LocalDate from "@/server/LocalDate";
import LocalTime from "@/server/LocalTime";
import Picker from "@/components/picker/Picker";
import FormValidatedField from "@/components/forms/FormValidatedField";

moment.suppressDeprecationWarnings = true;

export default {
  name: "DateTimePicker",
  components: {Picker},


  async mounted() {

    if (this.modelDate) {
      this.dateLoading = true;
      if (this.dateType === "Instant") {
        this.date = moment(this.modelDate);
      } else if (this.dateType === "LocalTime") {
        this.date = moment(this.modelDate.value, "HH:mm:ss");
      } else {
        this.date = moment(this.modelDate.value);
      }
    }

    if (this.format?.length > 0) {
      this.options.format = this.format;
    }
    // this.options.dateType = this.dateType;
    // this.options.parseInputDate = (input) => {
    //   // zawsze traktuj jako ISO / RFC 3339
    //   return moment(input);
    // };
    if (this.useCurrent) {
      this.options.useCurrent = this.useCurrent;
    }

    if (this.minDate || this.maxDate) {
      let now = moment();
      let minDate = moment(this.minDate);
      let maxDate = moment(this.maxDate);
      if (minDate && maxDate) {
        if (now > minDate && now < maxDate) {
          this.options.showTodayButton = true;
        } else {
          this.options.showTodayButton = false;
        }
      } else if (now > minDate) {
        this.options.showTodayButton = true;
      } else if (now < maxDate) {
        this.options.showTodayButton = true;
      } else {
        this.options.showTodayButton = false;
      }
    }

    if (this.minDate && this.dateType !== "LocalTime") {
      this.options.minDate = moment(this.minDate);
    }
    if (this.maxDate && this.dateType !== "LocalTime") {
      this.options.maxDate = moment(this.maxDate);
    }
    if (this.excludedDays?.length > 0) {
      this.options.disabledDates = [];
      for (let i = 0; i < this.excludedDays.length; i++) {
        this.options.disabledDates.push(moment(this.excludedDays[i]));
      }
    }

    if (this.excludedHours?.length > 0) {
      this.options.disabledHours = this.excludedHours;
    }

    if (this.excludedWeekends) {
      this.options.daysOfWeekDisabled = [0, 6];
      let now = moment();
      let day = now.day();
      if (day === this.options.daysOfWeekDisabled[0] || day === this.options.daysOfWeekDisabled[1]) {
        this.options.showTodayButton = false;
      }
    }
    setTimeout(() => {
      if (this.excludedDayField) {
        let instance = this.validatedField.validatedForm.originalSource;
        if (instance) {
          this.watchedExcludedDays = this.validatedField.validatedForm.originalSource.excludedDays;
        }
      }
    });
  },

  methods: {

    changeModel() {
      let momentDate = null;
      if (this.date == null) {
        this.$emit('model-change', null);
        return;
      }

      if (this.dateType === "LocalDateTime" || this.dateType === "LocalDate" || this.dateType === "Instant") {
        momentDate = moment(this.date);
      } else if (this.dateType === "LocalTime") {
        if (typeof this.date === "string" && this.dateLoading) {
          let time = moment(this.date);
          momentDate = moment(time, "HH:mm:ss");
          this.dateLoading = false;
        } else {
          momentDate = moment(this.date, "HH:mm:ss");
        }
      }

      if (momentDate && momentDate.isValid()) {
        if (this.dateType === "LocalDateTime") {
          let localDateTime = new LocalDateTime();
          localDateTime.fromMoment(momentDate);
          this.$emit('model-change', localDateTime);
        } else if (this.dateType === "LocalDate") {
          let localDate = new LocalDate();
          localDate.fromMoment(momentDate);
          this.$emit('model-change', localDate);
        } else if (this.dateType === "LocalTime") {
          let localTime = new LocalTime();
          localTime.fromMoment(momentDate);
          this.$emit('model-change', localTime);
        } else if (this.dateType === "Instant") {
          this.$emit('model-change', momentDate);
        }
      }
    },

  },

  model: {
    prop: 'modelDate',
    event: 'model-change',
  },

  props: {
    customFocusOnHide: {default: null},
    modelDate: {default: null},
    readOnly: {type: Boolean, default: true},
    placeholder: {type: String, default: ""},
    excludedWeekends: {type: Boolean, default: false},
    useCurrent: {type: Boolean, default: false},
    label: {type: String, default: null},
    minDate: {type: String, default: null},
    maxDate: {type: String, default: null},
    format: {type: String, default: ""},
    dateType: {type: String, default: ""},
    excludedDays: {
      type: Array, default: function () {
        return []
      }
    },
    excludedHours: {
      type: Array, default: function () {
        return []
      }
    },
    excludedDayField: {type: String, default: null},
    validatedField: {type: FormValidatedField, required: true},
  },

  watch: {
    date: function (newVal, oldVal) {
      this.changeModel();
    },
    watchedExcludedDays: function (val) {
      this.$emit("update-excluded-days", val);
    },
    excludedDays: function (daysArr) {
      if (daysArr?.length) {
        let daysConverted = [];
        for (let day of daysArr) {
          daysConverted.push(moment(day));
        }
        this.options.disabledDates = daysConverted;
      } else {
        this.options.disabledDates = [];
      }
    },
  },

  data: () => ({
    watchedExcludedDays: "",
    dateLoading: null,
    date: null,
    options: {
      widgetParent: "#globalPopupGlass",
      showTodayButton: true,
      showClear: true,
      showClose: true,
      minDate: false,
      maxDate: false,
      disabledDates: false,
      disabledHours: false,
      useCurrent: false,
      format: false,
      daysOfWeekDisabled: [],
      ignoreReadonly: true,
      calendarWeeks: true
      // keepOpen: true // after selected date
    }
  })
}
</script>

